import Axios from '../config/Axios';

/**
 * @param {object} params
 * @param {string} [params.cSearch]
 * @param {string} [params.cOrderBy]
 * @param {string} [params.cOrderType]
 */
export function myPendingDocumentsDelegated(params = {}) {
  return Axios.get('/my-account/pending-document', { params: { bResponsible: false, ...params } }).then(
    (oResponse) => oResponse.data
  );
}

/**
 * @param {object} params
 * @param {string} [params.cSearch]
 * @param {string} [params.cOrderBy]
 * @param {string} [params.cOrderType]
 */
export function myPendingDocumentsResponsible(params = {}) {
  return Axios.get('/my-account/pending-document', { params: { bResponsible: true, ...params } }).then(
    (oResponse) => oResponse.data
  );
}

export function documentsIAmResponsibleSearchFor() {
  return Axios.get('my-account/pending-document-search', { params: { "bResponsible": true } }).then(
    (oResponse) => oResponse.data
  );
}
